import React, { Component } from "react";
import OrdersByShipmentTable from "../Orders/Table/_OrdersByShipmentTable";
import ShipmentsListContainer from "../Shipments/_ShipmentsList";
import { Box } from "reflexbox";

class Planning extends Component {
  render() {
    return (
      <Box flex justify="space-between">
        <Box w={0.13}>
          <ShipmentsListContainer />
        </Box>
        <Box w={0.86}>
          <OrdersByShipmentTable />
        </Box>
      </Box>
    );
  }
}

export default Planning;



// WEBPACK FOOTER //
// ./src/views/Planning/index.js